import React, { useMemo } from 'react'
import * as Summary from "../styles";
import ButtonRecaptchaBase from "components/ButtonRecaptcha";
import { Skeleton } from "antd";
import { formatCurrency } from "utils";
import { Button } from "components/Button";
import { useInstallments } from "components/PaymentForm/hooks/useInstallment";
import usePayment from "hooks/usePayment";
import { SummaryDividerDashed, SummaryRow, TaxLabel, TaxSectionTitle, TaxValue } from "../../PaymentAmmountSummaryCard/styles";

interface Props {
  setTokenRecaptcha: (token: string | null) => void;
  tokenRecaptcha: string | null;
  isLoadingInstallments: boolean;
  handleGoToPayment: () => void;
  isLoading: boolean
}

const MULTIPLE_PAYMENT = 2

const SummaryValue: React.FC<Props> = ({ isLoadingInstallments, setTokenRecaptcha, tokenRecaptcha, handleGoToPayment, isLoading }) => {
  const { installments, paymentMethods } = usePayment();
  const { handleInstallmentInfo } = useInstallments()

  const infoValues = useMemo(() => {
    if (paymentMethods.length === MULTIPLE_PAYMENT) {
      return {
        fee: installments.multiple.fee_amount,
        original_value: installments.multiple.original_amount,
        operation_cost: installments.multiple?.operation_cost || 0,
        convenience_fee: installments.multiple?.convenience_fee || 0,
        total: installments.multiple.total_amount
      }
    }

    const paymentInfo = handleInstallmentInfo(paymentMethods[0], 0)

    return {
      original_value: paymentInfo.original_amount,
      operation_cost: paymentInfo?.operation_cost || 0,
      convenience_fee: paymentInfo?.convenience_fee || 0,
      fee: paymentInfo.fee_amount,
      total: paymentInfo.total_amount
    }
  }, [installments])

  const isVisibleFees = useMemo(() => {
    return infoValues?.convenience_fee > 0 && infoValues?.operation_cost > 0
  }, [infoValues])

  return (
    <Summary.SummaryCard>
      <Summary.SummaryRow>
        <Summary.SummaryLabel>Débitos</Summary.SummaryLabel>
        <Summary.SummaryValue>
          {isLoadingInstallments ? <Skeleton.Input style={{ width: "100px" }} size="small" active /> : formatCurrency(infoValues.original_value)}
        </Summary.SummaryValue>
      </Summary.SummaryRow>

      {!isVisibleFees && <Summary.SummaryRow>
        <Summary.SummaryLabel>Tarifa de serviço</Summary.SummaryLabel>
        <Summary.SummaryValue>
          {isLoadingInstallments ? <Skeleton.Input style={{ width: "100px" }} size="small" active /> : formatCurrency(infoValues.fee)}
        </Summary.SummaryValue>
      </Summary.SummaryRow>}

      {isVisibleFees && <>
        <TaxSectionTitle>Taxas</TaxSectionTitle>
        <SummaryDividerDashed />
        <SummaryRow>
          <TaxLabel>Custo financeiro</TaxLabel>
          <TaxValue>{formatCurrency(infoValues.operation_cost)}</TaxValue>
        </SummaryRow>
        <SummaryRow>
          <TaxLabel>Taxa de conveniência</TaxLabel>
          <TaxValue>{formatCurrency(infoValues.convenience_fee)}</TaxValue>
        </SummaryRow>
      </>
      }

      <Summary.SummaryDivider />
      <Summary.SummaryRow>
        <Summary.SummaryLabel>Total</Summary.SummaryLabel>
        <Summary.SummaryTotal>
          {isLoadingInstallments ? <Skeleton.Input style={{ width: "100px" }} size="small" active /> : formatCurrency(infoValues.total)}
        </Summary.SummaryTotal>
      </Summary.SummaryRow>
      <ButtonRecaptchaBase onVerify={setTokenRecaptcha} style={{ width: "100px" }} />
      <Button
        title="Finalizar pagamento"
        type_button="primary"
        style={{ marginTop: "5px" }}
        paddingHorizontal={0}
        onClick={handleGoToPayment}
        disabled={!tokenRecaptcha}
        loading={isLoading}
      />
      <Summary.TermsText>
        Ao finalizar o pagamento, eu aceito os{" "}
        <Summary.TermsLink href="#">termos de uso</Summary.TermsLink>.
      </Summary.TermsText>
    </Summary.SummaryCard >
  )
}

export default SummaryValue